import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  detail: null,
};

export const planMedicineSlice = createSlice({
  name: 'planMedicine',
  initialState,
  reducers: {
    addPlanMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPlanMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOnePlanMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    successPlanMedicine: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = Array.isArray(action.payload) ? action.payload : [];
    },
    successOnePlanMedicine: (state, action) => {
      state.loading = false;
      state.error = null;
      state.detail = action.payload || null;
    },
    failedPlanMedicine: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removePlanMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePlanMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
  },
});

export const {
  addPlanMedicine,
  getPlanMedicine,
  getOnePlanMedicine,
  successPlanMedicine,
  successOnePlanMedicine,
  failedPlanMedicine,
  removePlanMedicine,
  updatePlanMedicine,
} = planMedicineSlice.actions;

export default planMedicineSlice.reducer;
